export const API_CONFIG = {
    baseUrl: import.meta.env.PROD ? "https://api-scoutdeck.qastan.be/" :  "http://localhost:3000/",
    trpcUrl: import.meta.env.PROD ? "https://api-scoutdeck.qastan.be/trpc": "http://localhost:3000/trpc"
}